import { html } from 'lit';
import { service } from '@src/service/index.js';
import { TRACKER_EVENT_NAME_CANCEL_CHANGE_PERMISSION } from '@src/service/tracker.js';
import { saveAndLoad, cancelEditMode } from '@src/store/consents.js';
import { store } from '@src/store/index.js';
import { ConsentGroup } from '@src/types/common.js';

export const viewTemplate = (
  consentGroup: ConsentGroup,
  editmodeActiveGroupInd: number,
  changesMade: boolean,
) => html`
  <tef-coms-consent-group
    role="region"
    .consentGroup=${consentGroup}
    .groupIndex=${editmodeActiveGroupInd}
    data-testid="group-${consentGroup.name.toLowerCase()}">
  </tef-coms-consent-group>

  <one-button-group>
    <one-button .disabled=${!changesMade} @click=${() => { store.dispatch(saveAndLoad()); }}>Speichern</one-button>
    <one-spacer size="fill"></one-spacer>
    <one-button variant="plain" @click=${() => {
    store.dispatch(cancelEditMode());
    service.tracker.doTracking(TRACKER_EVENT_NAME_CANCEL_CHANGE_PERMISSION, { group: consentGroup.name });
  }}>Abbrechen</one-button>
  </one-button-group>`;
